<section class="px-container embed-container">
    <div id="content">
    </div>
    <phx-back-to-top [scrollHeight]="100"></phx-back-to-top>
</section>